import { useDispatch, useSelector } from "react-redux";
import { Drawer } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { RootState } from "../../../shared/types/common";
import { showNotification } from "../../../shared/utils/utils";
import {
  createDocumentType,
  updateDocumentType,
} from "../../../core/store/reducers/document-type.slice";

interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
}

const CreateEditDocumentTypeComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { screenType } = useSelector((state: RootState) => state.settings);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        documentTypeName: selectedEntity?.documentTypeName,
        status: selectedEntity?.status,
      });
    } else {
      form.resetFields();
    }
  }, [form, selectedEntity]);

  const onFinish = async (values: any) => {
  setSaving(true);

  const payload = {
    documentTypeName: values?.documentTypeName,
    status: values?.status,
  };

  const action = selectedEntity
    ? updateDocumentType({
        id: selectedEntity?.id,
        body: payload,
      })
    : createDocumentType(payload);

  try {
    const val: any = await dispatch(action);

    if (val?.payload?.data) {
      showNotification(
        selectedEntity
          ? "Document Type Updated Successfully"
          : "Document Type Created Successfully",
        "success"
      );

      onSubmit();
    }
  } finally {
    setSaving(false);
  }
};

  const colSpan = screenType.isPortrait ? 24 : 12;

  const formProps = {
    form: form,
    name: "create-edit-document-type",
    heading: selectedEntity ? "Edit Document Type" : "Add New Document Type",
    initialValues: {
      status: "ACTIVE",
    },
    formElements: [
      {
        name: "documentTypeName",
        colSpan: 24,
        label: "Document Type Name",
        placeholder: "e.g. Passport",
        type: "Input",
        allowClear: true,
        rules: [{ required: true, message: "Please enter a document type name" }],
      },
      {
        name: "status",
        label: "Status",
        placeholder: "Status",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: [
          { value: "ACTIVE", label: "ACTIVE" },
          { value: "INACTIVE", label: "INACTIVE" },
        ],
        rules: [{ required: true, message: "Please select a status" }],
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: saving,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: () => {
      return;
    },
    onValuesChange: () => {
      return;
    },
  };

  return (
    <Drawer
      maskClosable={false}
      title={<strong>{formProps.heading}</strong>}
      className="form-drawer"
      width={
        screenType.isPortrait
          ? "90%"
          : screenType.isLg || screenType.isXl
          ? 720
          : 500
      }
      onClose={onClose}
      open={visible}
    >
      <GenericFormComponent {...formProps} />
    </Drawer>
  );
};

export default CreateEditDocumentTypeComponent;
